import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_JobManager = _resolveComponent("JobManager");
    return (_openBlock(), _createElementBlock("span", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Jobs: Running/Completed", -1)),
        _createVNode(_component_JobManager)
    ]));
}
